<template>
    <div class="ContactPage">

		<div class="ContactPage__map">
			<Map />
		</div>

		<div class="ContactPage__content">
			<div class="container">

				<div class="category">
					<div class="title">
						<CellphoneIcon class="icon" />
						<h5>{{ $t('ContactTelephone') }}</h5>
					</div>

					<div class="info">
						<div>
							<p>+387 66 370 188</p>
						</div>
						<div>
							<p>+387 66 370 193</p>
						</div>
					</div>
				</div>

				<div class="category">
					<div class="title">
						<HomeIcon class="icon" />
						<h5>{{ $t('ContactAddress') }}</h5>
					</div>

					<div class="info">
						<div>
							<p>Srđana Aleksića br. 14 Sarajevo, Bosnia and Herzegovina 71000</p>
						</div>
					</div>
				</div>

				<div class="category">
					<div class="title">
						<EmailIcon class="icon" />
						<h5>{{ $t('ContactEmail') }}</h5>
					</div>

					<div class="info">
						<div>
							<p>info@rocketprint.ba</p>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
import CellphoneIcon from 'vue-material-design-icons/Cellphone.vue'
import EmailIcon from 'vue-material-design-icons/Email.vue'
import HomeIcon from 'vue-material-design-icons/Home.vue'
import Map from '@/components/Map/Map'

export default {
	name: 'ContactPage',
	components: {
		CellphoneIcon,
		EmailIcon,
		HomeIcon,
		Map
	}
}
</script>

<style lang="scss" scoped>

.ContactPage {
	padding-top: 80px;

	@media screen and (min-width: 1024px) {
		display: flex;
	}

	&__map {
		width: 100vw;
		height: 60vh;

		@media screen and (min-width: 768px) {
			height: 70vh;
		}
		@media screen and (min-width: 1024px) {
			height: auto;
		}
	}

	&__content {
		background: $blue;

		@media screen and (min-width: 1024px) {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}

		.container {
			width: 100%;
			padding: 20px;

			.category {
				margin: 20px 0;

				.title {
					text-align: center;
					display: flex;
					justify-content: center;

					.icon {
						background: #fff;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 30px;
						height: 30px;
						border-radius: 100%;
						color: $blue;
						margin-right: 10px;
						margin-top: -5px;
						font-size: 1.2em;
					}

					h5 {
						margin: 0;
						text-transform: uppercase;
						color: white;
						font-size: 1.2em;
						font-weight: 600;
					}
				}

				.info {
					display: flex;
					justify-content: space-around;
					text-align: center;

					div {
						width: 100%;
						margin: 0 10px;

						p {
							color: white;
							font-size: 0.9em;
							
						}
					}
				}

				&:first-child {
					.info {
						div:first-child {
							text-align: right;
						}
						div:last-child {
							text-align: left;
						}
					}
				}
			}
		}
	}

}

/deep/ {
	.material-design-icon__svg {
		bottom: 5px;
	}
}
</style>
